import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "welcome-root" }
const _hoisted_2 = { class: "logo-bar" }
const _hoisted_3 = { class: "logo-bar-inner" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "logo-fallback-top"
}
const _hoisted_6 = { class: "panels-row" }
const _hoisted_7 = { class: "left-panel" }
const _hoisted_8 = { class: "left-content" }
const _hoisted_9 = { class: "features-grid" }
const _hoisted_10 = { class: "feature-icon-wrapper" }
const _hoisted_11 = { class: "feature-content" }
const _hoisted_12 = { class: "feature-title" }
const _hoisted_13 = { class: "feature-desc" }
const _hoisted_14 = { class: "right-panel" }
const _hoisted_15 = { class: "greeting-card" }
const _hoisted_16 = { class: "header-badge" }
const _hoisted_17 = { class: "greeting-label" }
const _hoisted_18 = { class: "greeting-name" }
const _hoisted_19 = { class: "meta-wrap" }
const _hoisted_20 = { class: "meta-chip" }
const _hoisted_21 = {
  key: 0,
  class: "meta-chip"
}
const _hoisted_22 = { class: "footer-links" }
const _hoisted_23 = { class: "footer-link" }
const _hoisted_24 = { class: "footer-link" }
const _hoisted_25 = { class: "footer-link" }
const _hoisted_26 = { class: "copyright-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "animated-bg" }, [
      _createElementVNode("div", { class: "gradient-orb orb-1" }),
      _createElementVNode("div", { class: "gradient-orb orb-2" }),
      _createElementVNode("div", { class: "gradient-orb orb-3" })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.logoError)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.logoSrc,
              alt: "ERA ERP",
              class: "top-logo",
              onError: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logoError = true))
            }, null, 40, _hoisted_4))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("span", { class: "era-text-top" }, "ERA", -1)
            ]))])),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "logo-bar-tagline" }, "Enterprise Resource Application", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "welcome-title" }, [
            _createElementVNode("span", { class: "gradient-text" }, "Bine ați venit")
          ], -1)),
          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "welcome-subtitle" }, "Sistem ERP Enterprise de Ultimă Generație", -1)),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (f, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "feature-card",
                key: i
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_v_icon, {
                    color: f.color,
                    size: "26"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(f.icon), 1)
                    ]),
                    _: 2
                  }, 1032, ["color"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("h3", _hoisted_12, _toDisplayString(f.title), 1),
                  _createElementVNode("p", _hoisted_13, _toDisplayString(f.desc), 1)
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_v_icon, {
              size: "18",
              color: "#ff5722"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("mdi-check-circle", -1)
              ]))]),
              _: 1
            }),
            _cache[6] || (_cache[6] = _createElementVNode("span", null, "Autentificat cu succes", -1))
          ]),
          _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.greetingIcon) + "  " + _toDisplayString(_ctx.greetingText), 1),
          _createElementVNode("h2", _hoisted_18, _toDisplayString(_ctx.username), 1),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("span", _hoisted_20, [
              _cache[7] || (_cache[7] = _createElementVNode("i", { class: "mdi mdi-calendar-today" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.formattedDate), 1)
            ]),
            (_ctx.companyName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                  _cache[8] || (_cache[8] = _createElementVNode("i", { class: "mdi mdi-office-building-outline" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.companyName), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "card-divider" }, null, -1)),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("span", _hoisted_23, [
              _createVNode(_component_v_icon, { size: "15" }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode("mdi-lifebuoy", -1)
                ]))]),
                _: 1
              }),
              _cache[10] || (_cache[10] = _createTextVNode(" Centru Ajutor ", -1))
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "link-sep" }, "•", -1)),
            _createElementVNode("span", _hoisted_24, [
              _createVNode(_component_v_icon, { size: "15" }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode("mdi-shield-check", -1)
                ]))]),
                _: 1
              }),
              _cache[12] || (_cache[12] = _createTextVNode(" Securitate ", -1))
            ]),
            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "link-sep" }, "•", -1)),
            _createElementVNode("span", _hoisted_25, [
              _createVNode(_component_v_icon, { size: "15" }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode("mdi-file-document-outline", -1)
                ]))]),
                _: 1
              }),
              _cache[14] || (_cache[14] = _createTextVNode(" Termeni ", -1))
            ])
          ])
        ]),
        _createElementVNode("p", _hoisted_26, "© " + _toDisplayString(_ctx.currentYear) + " Else Digital Solutions S.R.L.", 1)
      ])
    ])
  ]))
}